import { jsx as _jsx } from "react/jsx-runtime";
import { FormUI } from "@parkschannel/ui";
import { FormProvider } from "react-hook-form";
export function Form(param) {
    let { methods , ...rest } = param;
    return /*#__PURE__*/ _jsx(FormProvider, {
        ...methods,
        children: /*#__PURE__*/ _jsx(FormUI.Form, {
            ...rest
        })
    });
}
